import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { NgBrazil } from 'ng-brazil';
import { FilterCardComponent } from './components/cards/filter-card/filter-card.component';
import { StatusCardComponent } from './components/cards/status-card/status-card.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { FilterButtonComponent } from './components/filter-button/filter-button.component';
import { FilterComponent } from './components/filter/filter.component';
import { SearchComponent } from './components/search/search.component';
import { SlideToogleComponent } from './components/slide-toogle/slide-toogle.component';
import { Endpoints } from './endpoints/endpoints';
import { LoadingComponent } from './loading/loading.component';
import { MaterialModule } from './material-module';
import { PhonePipe } from './pipes/cellPhone.pipe';
import { StatusPipe } from './pipes/status.pipe';
import { TaxIdHiddenMaskPipe } from './pipes/tax-id-hidden-mask.pipe';
import { TaxIdMaskPipe } from './pipes/tax-id-mask.pipe';
import {
  AppMenuAnchorDirective,
  AppMenuDirective,
  AppMenuLinkDirective,
  AppSubmenuAnchorDirective,
  AppSubmenuDirective,
  AppSubmenuLinkDirective,
} from './sidebar-directive';
import { StepComponent } from './step/step.component';
import { TaxIdCompleteMaskPipe } from './pipes/tax-id-mask-complete.pipe';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TextMaskModule,
    NgBrazil,
    FlexLayoutModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  declarations: [
    AppMenuAnchorDirective,
    AppMenuLinkDirective,
    AppMenuDirective,
    AppSubmenuAnchorDirective,
    AppSubmenuLinkDirective,
    AppSubmenuDirective,
    LoadingComponent,
    StepComponent,
    FilterComponent,
    SlideToogleComponent,
    DropdownComponent,
    SearchComponent,
    FilterCardComponent,
    FilterButtonComponent,
    StatusCardComponent,
    StatusPipe,
    PhonePipe,
    TaxIdMaskPipe,
    TaxIdHiddenMaskPipe,
    TaxIdCompleteMaskPipe
  ],
  exports: [
    AppMenuAnchorDirective,
    AppMenuLinkDirective,
    AppMenuDirective,
    AppSubmenuAnchorDirective,
    AppSubmenuLinkDirective,
    AppSubmenuDirective,
    LoadingComponent,
    FormsModule,
    TextMaskModule,
    NgBrazil,
    StepComponent,
    FilterComponent,
    SlideToogleComponent,
    DropdownComponent,
    SearchComponent,
    FilterCardComponent,
    FilterButtonComponent,
    StatusCardComponent,
    StatusPipe,
    PhonePipe,
    TaxIdMaskPipe,
    TaxIdHiddenMaskPipe,
    TaxIdCompleteMaskPipe
  ],
  providers: [MenuItems, Endpoints, TaxIdMaskPipe]
})
export class SharedModule { }